
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">Last updated: January 2025</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">What Are Cookies?</h2>
            <p className="text-gray-700 mb-4">
              Cookies are small text files that are stored on your device when you visit our website. 
              They help us provide you with a better experience by remembering your preferences and 
              improving our services.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Types of Cookies We Use</h2>
            
            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Essential Cookies</h3>
            <p className="text-gray-700 mb-4">
              These cookies are necessary for the website to function properly. They enable basic 
              functions like page navigation, security, and access to secure areas of the website.
            </p>
            
            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Performance Cookies</h3>
            <p className="text-gray-700 mb-4">
              These cookies collect information about how visitors use our website, such as which 
              pages are visited most often. This data helps us improve our website performance.
            </p>
            
            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Functionality Cookies</h3>
            <p className="text-gray-700 mb-4">
              These cookies allow our website to remember choices you make and provide enhanced 
              features and personal content.
            </p>
            
            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Marketing Cookies</h3>
            <p className="text-gray-700 mb-4">
              These cookies track your online activity to help advertisers deliver more relevant 
              advertising or to limit how many times you see an ad.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Cookie Management</h2>
            <p className="text-gray-700 mb-4">
              You can control and manage cookies in various ways:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Use our cookie banner to accept or reject non-essential cookies</li>
              <li>Change your browser settings to block or delete cookies</li>
              <li>Use browser extensions that manage cookies</li>
              <li>Visit your browser's help pages for specific instructions</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Third-Party Cookies</h2>
            <p className="text-gray-700 mb-4">
              Some cookies on our website are set by third-party services:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Google Analytics - for website analytics</li>
              <li>Payment processors - for secure transactions</li>
              <li>Social media platforms - for social sharing features</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Your Choices</h2>
            <p className="text-gray-700 mb-4">
              You have the right to choose whether or not to accept cookies. However, please note 
              that blocking certain cookies may affect the functionality of our website.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have questions about our cookie policy, please contact us:
            </p>
            <ul className="list-none text-gray-700 mb-4">
              <li>Email: privacy@goldenticketlucky.com</li>
              <li>Phone: 1800 GOLDEN (+61359294105)</li>
            </ul>
            
            <div className="bg-yellow-50 p-6 rounded-lg mt-8">
              <p className="text-gray-700 font-medium">
                By continuing to use our website, you consent to our use of cookies as described 
                in this policy.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Cookies;
